import React from 'react';
import './PrivacyHero.css';

const PrivacyHero = () => {
  return (
    <section className="privacy-hero">
      <div className="container">
        <div className="privacy-hero-content">
          <h1 className="privacy-title">
            Privacy Policy
          </h1>
          <p className="privacy-subtitle">
            Learn how we collect, use, and protect your personal information
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyHero;
